import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, FileCheck } from 'lucide-react';
import { fetchVisas, resolveImageUrl } from '../lib/travelApi';

const PopularVisas = () => {
  const navigate = useNavigate();
  const [visas, setVisas] = useState([]);

  useEffect(() => {
    fetchVisas().then((d) => setVisas((d || []).slice(0, 4))).catch(() => setVisas([]));
  }, []);

  if (visas.length === 0) return null;

  return (
    <section className="py-20 bg-gray-50" data-testid="popular-visas">
      <div className="container mx-auto px-4">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between mb-10 gap-4">
          <div>
            <span className="text-amber-600 font-semibold uppercase tracking-wider text-sm">Visa Services</span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-2">Popular Visas</h2>
            <p className="text-gray-600 mt-2">We handle your visa end-to-end. Approximate fees below.</p>
          </div>
          <button
            onClick={() => navigate('/visa')}
            data-testid="popular-visas-viewall"
            className="inline-flex items-center gap-2 text-amber-600 hover:text-amber-700 font-semibold"
          >
            View all visas <ArrowRight className="w-4 h-4" />
          </button>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
          {visas.map((v) => (
            <div
              key={v.id}
              onClick={() => navigate('/visa')}
              data-testid={`popular-visa-${v.id}`}
              className="group relative rounded-xl overflow-hidden cursor-pointer shadow-md hover:shadow-2xl transition-all h-48"
            >
              {v.image ? (
                <img src={resolveImageUrl(v.image)} alt={v.country} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
              ) : (
                <div className="w-full h-full bg-amber-100 flex items-center justify-center"><FileCheck className="w-10 h-10 text-amber-600" /></div>
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="text-lg font-bold text-white">{v.country}</h3>
                {v.price > 0 && (
                  <p className="text-amber-300 font-semibold text-sm">~₹{Number(v.price).toLocaleString('en-IN')}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PopularVisas;
